import * as React from 'react';
import { CSSProperties } from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium from 'radium';
import { SplitButton, Dropdown, Button } from 'react-bootstrap'; // fixed import
import { connect } from 'react-redux';

type MenuItemProps = {
    onClick?: (category: string) => void;
    key?: number;
    category?: string;
    selected: boolean;
}

class _RealCampusDesignCatItem extends React.Component<MenuItemProps, any> {

    onClick = (category: string) => {
        if (this.props.onClick)
            this.props.onClick(category);
    }

    doFilter = () => {
        document.dispatchEvent(new MouseEvent('click'));
        
        this.onClick(this.props.category);
    }

    render() {
        return (
            <Dropdown.Item eventKey={this.props.key} onClick={this.doFilter}>
                {this.props.category}
            </Dropdown.Item>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
};

export var RealCampusDesignCatItem = connect(mapStateToProps)(Radium(_RealCampusDesignCatItem));
